/**
 * Bundle Cart - Smart Bundle Handling
 * 处理购物车中的 Bundle 产品联动
 */

(function() {
  'use strict';

  // 初始化
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  function init() {
    console.log('[Bundle Cart] Initializing...');
    setupBundleHandling();
  }

  /**
   * 设置 Bundle 处理
   */
  function setupBundleHandling() {
    // 查找所有 Bundle 产品
    const cartItems = document.querySelectorAll('.cart-item');
    const bundleMap = {};

    cartItems.forEach(item => {
      const bundleId = item.dataset.bundleId;
      const bundleType = item.dataset.bundleType;
      
      if (!bundleId) return;

      if (!bundleMap[bundleId]) {
        bundleMap[bundleId] = { main: null, components: [] };
      }

      if (bundleType === 'main') {
        bundleMap[bundleId].main = item;
      } else if (bundleType === 'frame' || bundleType === 'size') {
        bundleMap[bundleId].components.push(item);
        // 禁用组件的删除按钮
        disableRemoveButton(item);
      }
    });

    // 为每个主产品设置删除处理
    Object.keys(bundleMap).forEach(bundleId => {
      const group = bundleMap[bundleId];
      if (group.main) {
        setupMainProductRemoval(group.main, group.components);
      }
    });

    console.log('[Bundle Cart] Bundle map:', bundleMap);
  }

  /**
   * 禁用删除按钮（用于 Frame/Size 组件）
   */
  function disableRemoveButton(item) {
    const removeBtn = item.querySelector('cart-remove button, .cart-remove-button');
    if (removeBtn) {
      removeBtn.disabled = true;
      removeBtn.style.opacity = '0.3';
      removeBtn.style.cursor = 'not-allowed';
      removeBtn.title = 'Bundle component - remove main product instead';
    }
  }

  /**
   * 设置主产品删除处理
   */
  function setupMainProductRemoval(mainItem, components) {
    const removeBtn = mainItem.querySelector('cart-remove button, .cart-remove-button');
    if (!removeBtn) return;

    // 替换点击行为
    removeBtn.addEventListener('click', function(e) {
      // 确认删除
      if (!confirm('This will remove the entire bundle including frame and size options. Continue?')) {
        e.preventDefault();
        e.stopPropagation();
        return;
      }

      // 阻止默认删除行为
      e.preventDefault();
      e.stopPropagation();

      // 收集所有要删除的 line indices
      const linesToRemove = [];

      // 主产品
      const mainIndex = getLineIndex(mainItem);
      if (mainIndex) linesToRemove.push(mainIndex);

      // 组件
      components.forEach(component => {
        const index = getLineIndex(component);
        if (index) linesToRemove.push(index);
      });

      console.log('[Bundle Cart] Removing lines:', linesToRemove);

      // 发送删除请求
      removeCartLines(linesToRemove);
    }, true);
  }

  /**
   * 获取 cart item 的 line index
   */
  function getLineIndex(item) {
    // 从 quantity input 获取
    const qtyInput = item.querySelector('input[name="updates[]"]');
    if (qtyInput && qtyInput.dataset.index) {
      return qtyInput.dataset.index;
    }

    // 从 cart-remove 元素获取
    const removeEl = item.querySelector('cart-remove');
    if (removeEl && removeEl.dataset.index) {
      return removeEl.dataset.index;
    }

    // 从 ID 解析
    const id = item.id;
    if (id) {
      const match = id.match(/-(\d+)$/);
      if (match) return match[1];
    }

    return null;
  }

  /**
   * 删除购物车中的指定 lines
   */
  function removeCartLines(lines) {
    if (lines.length === 0) return;

    // 构建 updates 对象
    const updates = {};
    lines.forEach(line => {
      updates[line] = 0; // quantity 设为 0 表示删除
    });

    // 显示加载状态
    document.body.style.cursor = 'wait';

    fetch('/cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({ updates })
    })
    .then(response => {
      if (!response.ok) throw new Error('Update failed');
      return response.json();
    })
    .then(cart => {
      console.log('[Bundle Cart] Removed successfully:', cart);
      // 刷新页面显示更新后的购物车
      window.location.reload();
    })
    .catch(error => {
      console.error('[Bundle Cart] Error:', error);
      document.body.style.cursor = 'default';
      alert('Error removing bundle. Please try again or refresh the page.');
    });
  }

  // 购物车更新后重新处理
  document.addEventListener('cart:updated', function() {
    setTimeout(setupBundleHandling, 200);
  });

})();
